import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import store from '../../../store';
import {cssProperties} from '../../../css/cssProperties';
import {luminaryOptions} from '../../../sectionConfig';
import {getProductData} from '../../../util/getProductData';
import {selectProductModelId} from '../../../selectors';

@customElement('page-luminare')
export class PageLuminare extends connect(store)(LitElement) {

	static styles = [
		css`
		.lampSection {
			display: flex;
			width: 100vw;
		}

		.lampDescription {
			color: var(--color-black);
			font: var(--font-specsheet-print-light);
			line-height: 11px;
			margin-bottom: 20px;
			max-width: 90%;
			text-align: left;
		}

		.imgContainer {
			text-align: center;
			width: 50vw;
		}

		.imgContainer img {
		  	margin: auto;
			width: 100%;
			height: auto;
		}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.productData = state.productData.productData;
		this.lang = state.status.lang;
	}

	getValueFromProductData(featureId, featureValueId) {
		const pd = getProductData(featureId, this.productData);
		return pd?.values?.find(val => val.valueId === featureValueId);
	}

	render() {
		const s = this.state;
		const lmo = luminaryOptions.find( luminaryOption =>  luminaryOption.id === this.lightProfile.project.luminary);
		const description = lmo ? lmo.description[this.lang] : '';
		let image = '';
		if (lmo.hasOwnProperty('imageModelSpecific')) {
			image = lmo ? lmo.imageModelSpecific[selectProductModelId(s)].imageWhite : '';
		} else {
			image = lmo ? lmo.imageWhite : '';
		}

		return html`
		<specsheet-light-section>
			<page-header content-title="${msg('Selected luminaire')}"  label-choice="light"></page-header>
			<div class="lampSection">
				<div class="lampContainer">
					<div class="imgContainer">
						<img src="${image}"/>
				  	</div>
				</div>
				<div class="description">
					<p class="lampDescription">${description}</p>
					<features-full-list line-choice="no-line" class-name="new-pdf"></features-full-list>
				</div>
			</div>
			<page-footer></page-footer>
		`;
	}
}
